
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ErrorAlert } from './admin/setup/ErrorAlert';
import { SetupAdminForm } from './admin/setup/SetupAdminForm';
import { useSetupAdmin } from './admin/setup/useSetupAdmin';

const SetupAdmin: React.FC = () => {
  const { 
    form, 
    onSubmit, 
    isSubmitting, 
    error, 
    responseDetails,
    navigate
  } = useSetupAdmin();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Setup Admin Account</CardTitle>
          <CardDescription>
            Create the first admin user for your application
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ErrorAlert error={error || ''} details={responseDetails} />
          <SetupAdminForm 
            form={form} 
            onSubmit={onSubmit} 
            isSubmitting={isSubmitting} 
          />
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button variant="link" onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default SetupAdmin;
